import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAndroid = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 21,
	viewBox: "0 0 18 21",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.38231 2.4081C4.92199 1.17647 6.87499 0.440002 9 0.440002C11.125 0.440002 13.078 1.17647 14.6177 2.4081L16.0711 0.954722L17.4853 2.36893L16.0319 3.82231C17.2635 5.36199 18 7.31499 18 9.44V10.44H0V9.44C0 7.31499 0.73647 5.36199 1.9681 3.82231L0.51472 2.36893L1.92893 0.954722L3.38231 2.4081ZM0 12.44H18V19.44C18 19.9923 17.5523 20.44 17 20.44H1C0.44772 20.44 0 19.9923 0 19.44V12.44ZM6 7.44C6.55228 7.44 7 6.99228 7 6.44C7 5.88772 6.55228 5.44 6 5.44C5.44772 5.44 5 5.88772 5 6.44C5 6.99228 5.44772 7.44 6 7.44ZM12 7.44C12.5523 7.44 13 6.99228 13 6.44C13 5.88772 12.5523 5.44 12 5.44C11.4477 5.44 11 5.88772 11 6.44C11 6.99228 11.4477 7.44 12 7.44Z",
		fill: "black"
	})
});
export default SvgAndroid;
